import { PDFDocument,rgb } from "pdf-lib";

export const generatePdfBlob = async (formData) => {
  try {

    let pdfUrl;

    if(formData.nationality==="it"){
      pdfUrl = "/pdf/Registrazione_Persone_Fisiche_nuova_versione.pdf"; 
    }
    else if(formData.nationality==="en"){
      pdfUrl = "/pdf/Registrazione_Persone_Fisiche_EN_nuova_versione.pdf"; 
    }
    const response = await fetch(pdfUrl);

    if (!response.ok) {
      throw new Error("Failed to fetch the PDF template");
    }

    const pdfBytes = await response.arrayBuffer();
    const pdfDoc = await PDFDocument.load(pdfBytes);

    const page = pdfDoc.getPage(0);
             const page2 = pdfDoc.getPage(1);
             const page3 = pdfDoc.getPage(2);
             const page4 = pdfDoc.getPage(3);
             const page5 = pdfDoc.getPage(4);
             const page6 = pdfDoc.getPage(5);
   
    const identificationText = formData.nationality === "en" 
    ? "Authentication Code" 
    : "Codice di Identificazione";

// Convert the date format from yyyy-mm-dd to dd/mm/yyyy
      const formatDateForPDF = (dateString) => {
        if (!dateString) return "";
        
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
      };

      // Use the formatted date in the PDF
      const dataNascitaFormatted = formatDateForPDF(formData.dataNascita);
      const dataNascitaTitolareFormatted = formatDateForPDF(formData.dataNascitaTitolare);
      const dataScadFormatted = formatDateForPDF(formData.dataScadDoc);
      const dataRilascioFormatted = formatDateForPDF(formData.dataDoc);
      const dataScadTitolareFormatted = formatDateForPDF(formData.dataScadDocTitolare);
      const dataRilascioTitolareFormatted = formatDateForPDF(formData.dataDocTitolare);

      const translateDocumentType = (docType, nationality) => {
        if (nationality === "en") {
          switch (docType) {
            case "CARTA D'IDENTITÀ":
              return "IDENTITY DOCUMENT";
            case "PATENTE DI GUIDA":
              return "DRIVER'S LICENCE";
            case "PASSAPORTO":
              return "PASSPORT";
            default:
              return docType; 
          }
        }
        return docType;
      };

 

      let tipoDocTranslated  = translateDocumentType(formData.tipoDoc, formData.nationality);
      let  tipoDocTitolareTranslated = translateDocumentType(formData.tipoDocTitolare, formData.nationality);



             //DATI FORM
             page.drawText(`${formData.luogoForm}`, {
               x: 150,
               y: 58,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.dataForm}`, {
               x: 450,
               y: 58,
               size: 10,
               color: rgb(0, 0, 0),
             });
         
   
             //DATI PERSONALI
             page.drawText(`${formData.cognome} ${formData.nome}`, {
               x: 200,
               y: formData.nationality === "it" ? 605 : 607,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             if(formData.sesso == "Femmina"){
             page.drawText(`X`, {
              x: 543,
              y: 603,
              size: 10,
              color: rgb(0, 0, 0),
            });
            }
            else{
              page.drawText(`X`, {
                x: 514,
                y: 603,
                size: 10,
                color: rgb(0, 0, 0),
              });
            }

             page.drawText(`${formData.codiceFiscale}`, {
               x: formData.nationality === "it" ? 190 : 230,
               y: 440,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.indirizzo}`, {
               x: 210,
               y: 580,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.numCiv}`, {
              x: 515,
              y: 580,
              size: 10,
              color: rgb(0, 0, 0),
            });

             page.drawText(`${formData.cap}`, {
               x: 150,
               y: 550,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             if (formData.stato === "IT") { 
               page.drawText(`${formData.comuneResid}`, { 
                 x: 280,
                 y: 550,
                 size: 10,
                 color: rgb(0, 0, 0),
               });

               page.drawText(`${formData.provincia}`, {
                x: 508,
                y: 550,
                size: 10,
                color: rgb(0, 0, 0),
              });
              
             } else {
               page.drawText(`${formData.localitaResid}`, {
                 x: 280,
                 y: 550,
                 size: 10,
                 color: rgb(0, 0, 0),
               });
             }          
    
            
         
             page.drawText(`${formData.stato}`, {
              x: 540,
              y: 550,
              size: 10,
              color: rgb(0, 0, 0),
            });
        
             page.drawText(`${dataNascitaFormatted}`, {
               x: formData.nationality === "it" ? 170 : 185,
               y: 465,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
   
             if(formData.statoNascita === "IT"){
   
             page.drawText(`${formData.comuneNascita} `, {
               x: formData.nationality === "it" ? 298 : 335,
               y: 465,
               size: 10,
               color: rgb(0, 0, 0),
             });
             page.drawText(`${formData.provinciaNascita} `, {
              x: 505,
              y: 465,
              size: 10,
              color: rgb(0, 0, 0),
            });

            page.drawText(`${formData.statoNascita} `, {
              x: 540,
              y: 465,
              size: 10,
              color: rgb(0, 0, 0),
            });
              }
             else{
             page.drawText(`${formData.luogoNascita} `, {
               x: formData.nationality === "it" ? 298 : 335,
               y: 465,
               size: 10,
               color: rgb(0, 0, 0),
             });

             page.drawText(`${formData.statoNascita} `, {
              x: 540,
              y: 465,
              size: 10,
              color: rgb(0, 0, 0),
            });
             }
           
             page.drawText(`${formData.telefono}`, {
               x: formData.nationality === "it" ? 140 : 155,
               y: 520,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.cellulare}`, {
               x: formData.nationality === "it" ? 290 : 307,
               y: 520,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.fax}`, {
               x: 440,
               y: 520,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.email}`, {
               x: 150,
               y: 495,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.pec}`, {
               x: formData.nationality === "it" ? 360 : 390,
               y: 495,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${tipoDocTranslated}`, {
               x: 210,
               y: 140,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.numDoc}`, {
               x: 400,
               y: 140,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${dataRilascioFormatted}`, {
               x: formData.nationality === "it" ? 150 : 180,
               y: 120,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${dataScadFormatted}`, {
               x: 400,
               y: 120,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.rilascioDoc}`, {
               x: 180,
               y: 95,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             //DATI DITTA
   
             page.drawText(`${formData.ragSociale}`, {
               x: 190,
               y: 405,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.indirizzoDitta}`, {
               x: 160,
               y: 380,
               size: 10,
               color: rgb(0, 0, 0),
             });

             page.drawText(`${formData.numCivDitta}`, {
              x: 515,
              y: 380,
              size: 10,
              color: rgb(0, 0, 0),
            });
   
             page.drawText(`${formData.capDitta}`, {
               x: 150,
               y: 350,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             if(formData.statoDitta === "IT"){
             page.drawText(`${formData.comuneDitta}`, {
               x: 280,
               y: 350,
               size: 10,
               color: rgb(0, 0, 0),
             });

             page.drawText(`${formData.provDitta}`, {
              x: 510,
              y: 350,
              size: 10,
              color: rgb(0, 0, 0),
            });
           }
           else{
             page.drawText(`${formData.localitaDitta}`, {
               x: 280,
               y: 350,
               size: 10,
               color: rgb(0, 0, 0),
             });
           }
            

             page.drawText(`${formData.statoDitta}`, {
              x: 543,
              y: 350,
              size: 10,
              color: rgb(0, 0, 0),
            });
   
             page.drawText(`${formData.telefonoDitta}`, {
               x: formData.nationality === "it" ? 140 : 175,
               y: 320,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.faxDitta}`, {
               x: 350,
               y: 320,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.emailDitta}`, {
               x: 150,
               y: 297,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.pIva}`, {
               x: 170,
               y: 270,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
   
             page.drawText(`${formData.pecDitta}`, {
               x: 330,
               y: 210,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${formData.pecDitta}`, {
               x: 330,
               y: 210,
               size: 10,
               color: rgb(0, 0, 0),
             });
   
             page.drawText(`${identificationText}: ${formData.authCode}`, {
               x: 380,
               y: 28,
               size: 10,
               color: rgb(0, 0, 0),
           });
             //SDI CODE
   
           const sdiCode = formData.sdiCode || ""; // Ensure sdiCode exists and is a string
           const startXSDI = 253; // Starting x-coordinate
           const startYSDI = 230; // y-coordinate (same for all characters)
           const charSpacing = 17; // Spacing between characters
   
           // Loop through each character in the SDI code
           sdiCode.split("").forEach((char, index) => {
           page.drawText(char, {
               x: startXSDI + index * charSpacing, // Increment x-coordinate for each character
               y: startYSDI,
               size: 11,
               color: rgb(0, 0, 0),
           });
           });
   
   
         //------------------------------------------------------------------------- SECOND PAGE ----------------------------------------------------------------------------------
   
           page2.drawText(`${formData.cognome} ${formData.nome}`, {
               x: formData.nationality === "it" ? 80 : 90,
               y: 223,
               size: 8,
               color: rgb(0, 0, 0),
               });
   
           page2.drawText(`${formData.codiceFiscale}`, {
               x:formData.nationality === "it" ? 245 : 335,
               y: 223,
               size: 8,
               color: rgb(0, 0, 0),
           });
   
   
           if (formData.consensoA === "allow") {
               page2.drawText("X", {
                 x: formData.nationality === "it" ? 53 : 54,
                 y: 173,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             } else if (formData.consensoA === "deny") {
               page2.drawText("X", {
                 x: formData.nationality === "it" ? 167 : 176,
                 y: 173,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             }
   
             page2.drawText(`${formData.emailNewsletter}`, {
               x: formData.nationality === "it" ? 320 : 340,
               y: 178,
               size: 9,
               color: rgb(0, 0, 0),
           });
           
   
   
           if (formData.consensoB1 === "allow") {
               page2.drawText("X", {
                 x: 53, 
                 y: 91,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             } else if (formData.consensoB1 === "deny") {
               page2.drawText("X", {
                 x: 210, 
                 y: 91,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             }
   
   
             if (formData.consensoB2 === "allow") {
               page2.drawText("X", {
                 x: 53, 
                 y: 61,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             } else if (formData.consensoB2 === "deny") {
               page2.drawText("X", {
                 x: 210, 
                 y: 61,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
             }
   
             page2.drawText(`${formData.luogoForm}, ${formData.dataForm}`, {
               x: 85,
               y: 35,
               size: 9,
               color: rgb(0, 0, 0),
           });
   
           page2.drawText(`${identificationText}: ${formData.authCode}`, {
             x: formData.nationality === "it" ? 408 : 435,
             y: 35,
             size: 9,
             color: rgb(0, 0, 0),
         });
   
           const checkboxNewsCoordinates = {
               checkboxArteModerna: { x: 32, y: 158 },
               checkboxDipinti: { x: 188, y: 158 },
               checkboxOrologi: { x: formData.nationality === "it" ? 311 : 331, y: 158 },
               checkboxVini: { x: formData.nationality === "it" ? 438 : 459, y: 158 },
               checkboxGioielli: { x: 32, y: 142 },
               checkboxAntiquariato: { x: 188, y: 142 },
               checkboxTappeti: { x: formData.nationality === "it" ? 311 : 332, y: 142 },
               checkboxLuxury: { x:  formData.nationality === "it" ? 438 : 459, y: 142 },
             };
           
             Object.entries(checkboxNewsCoordinates).forEach(([key, { x, y }]) => {
               if (formData[key]) { 
                 page2.drawText("X", {
                   x,
                   y,
                   size: 11,
                   color: rgb(0, 0, 0),
                 });
               }
             });
   
   
                   //------------------------------------------------------------------------- THIRD PAGE ----------------------------------------------------------------------------------
   
           page3.drawText(`${formData.dataForm}`, {
               x: 440,
               y: formData.nationality === "it" ? 190 : 276,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page3.drawText(`${identificationText}: ${formData.authCode}`, {
             x: formData.nationality === "it" ? 405 : 402,
             y: formData.nationality === "it" ? 145 : 231,
             size: 10,
             color: rgb(0, 0, 0),
             });
   
             page3.drawText(`${identificationText}: ${formData.authCode}`, {
               x: formData.nationality === "it" ? 405 : 402,
               y: formData.nationality === "it" ? 49 : 129,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
                   //------------------------------------------------------------------------- FOURTH PAGE ----------------------------------------------------------------------------------
           page4.drawText(`${formData.cognome} ${formData.nome}`, {
               x: formData.nationality === "it" ? 200 : 205,
               y: 650,
               size: 10,
               color: rgb(0, 0, 0),
               });
   
               if(formData.sesso == "Femmina"){
                page4.drawText(`X`, {
                 x: 539,
                 y: 648,
                 size: 11,
                 color: rgb(0, 0, 0),
               });
               }
               else{
                 page4.drawText(`X`, {
                   x: 501,
                   y: 648,
                   size: 11,
                   color: rgb(0, 0, 0),
                 });
               }
           page4.drawText(`${formData.codiceFiscale}`, {
               x: 200,
               y: 625,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${formData.indirizzo}`, {
               x: 160,
               y: 543,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${formData.numCiv}`, {
               x: 545,
               y: 543,
               size: 10,
               color: rgb(0, 0, 0),
           });
           
           if(formData.stato === "IT"){
           page4.drawText(`${formData.comuneResid}`, {
               x: formData.nationality === "it" ? 180 : 200,
               y: 568,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.provincia}`, {
            x: 415,
            y: 566,
            size: 10,
            color: rgb(0, 0, 0),
        });

         }
         else{
           page4.drawText(`${formData.localitaResid}`, {
             x: formData.nationality === "it" ? 180 : 200,
             y: 568,
             size: 10,
             color: rgb(0, 0, 0),
         });
         }
          
   
           page4.drawText(`${formData.stato}`, {
               x: 447,
               y: 566,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.cap}`, {
            x:formData.nationality === "it" ? 500 : 520,
            y: formData.nationality === "it" ? 566 : 567,
            size: 10,
            color: rgb(0, 0, 0),
        });
       
           page4.drawText(`${dataNascitaFormatted}`, {
               x: formData.nationality === "it" ? 500 : 525,
               y: 598,
               size: 10,
               color: rgb(0, 0, 0),
           });
           if(formData.statoNascita === "IT"){
   
           page4.drawText(`${formData.comuneNascita}`, {
               x: formData.nationality === "it" ? 150 : 190,
               y: 598,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.provinciaNascita}`, {
            x: 415,
            y: 598,
            size: 10,
            color: rgb(0, 0, 0),
        });
         }
         else{
           page4.drawText(`${formData.luogoNascita}`, {
             x: formData.nationality === "it" ? 150 : 190,
             y: 598,
             size: 10,
             color: rgb(0, 0, 0),
         });
         }
           page4.drawText(`${formData.statoNascita}`, {
               x: 449,
               y: 598,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${tipoDocTranslated} - ${formData.numDoc}`, {
               x: formData.nationality === "it" ? 227 : 180,
               y: 510,
               size: 8,
               color: rgb(0, 0, 0),
               });
   
   
           page4.drawText(`${formData.indirizzoDom}`, {
               x: 160,
               y: 446,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${formData.numCivDom}`, {
               x: 545,
               y: 446,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           if(formData.statoDom === "IT"){
           page4.drawText(`${formData.comuneDom}`, {
               x: formData.nationality === "it" ? 185 : 195,
               y: 480,
               size: 10,
               color: rgb(0, 0, 0),
           });
         }
         else{
           page4.drawText(`${formData.localitaDom}`, {
             x: formData.nationality === "it" ? 185 : 195,
             y: 480,
             size: 10,
             color: rgb(0, 0, 0),
         });
         }
           page4.drawText(`${formData.provDom}`, {
               x: 415,
               y: 478,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.capDom}`, {
            x: formData.nationality === "it" ? 500 : 520,
            y: 479,
            size: 10,
            color: rgb(0, 0, 0),
        });
   
           if(formData.indirizzoDom != '' ){

           page4.drawText(`${formData.statoDom}`, {
               x: 449,
               y: 478,
               size: 10,
               color: rgb(0, 0, 0),
           });
        }
   
           //CHECKBOX
   
   
           if (formData.pepOption === "pep") {
           page4.drawText("X", {
               x: 115, 
               y: 305,
               size: 11, 
               color: rgb(0, 0, 0),
           });
           } else if (formData.pepOption === "nonPep") {
               page4.drawText("X", {
                 x: 115, 
                 y: 326,
                 size: 11, 
                 color: rgb(0, 0, 0),
               });
           }
   
   
           if (formData.titolareOption === "ownAccount") {
           page4.drawText("X", {
               x: 116, 
               y: 207,
               size: 11, 
               color: rgb(0, 0, 0),
           });
           } else if (formData.titolareOption === "thirdParty") {
           page4.drawText("X", {
               x: 116, 
               y: 188,
               size: 11, 
               color: rgb(0, 0, 0),
           });
           }
   
           //TEXTAREA
   
           page4.drawText(`${formData.pepText}`, {
               x: 130,
               y: 263,
               size: 9,
               color: rgb(0, 0, 0),
           });
   
           //DATI TITOLARE
   
           page4.drawText(`${formData.cognomeTitolare} ${formData.nomeTitolare}`, {
               x:formData.nationality === "it" ? 203 : 205,
               y: formData.nationality === "it" ? 148 : 147,
               size: 10,
               color: rgb(0, 0, 0),
               });
   
          if(formData.sessoTitolare == "Femmina" && formData.nomeTitolare!= ""){
          page4.drawText(`X`, {
            x: 544,
            y: 145,
            size: 11,
            color: rgb(0, 0, 0),
          });
          }
          else if(formData.sessoTitolare == "Maschio" && formData.nomeTitolare!= ""){
            page4.drawText(`X`, {
              x: 506,
              y: 145,
              size: 11,
              color: rgb(0, 0, 0),
            });
          }
   
           page4.drawText(`${formData.codiceFiscaleTitolare}`, {
               x: 200,
               y: 120,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${formData.indirizzoTitolare}`, {
               x: 160,
               y: 31,
               size: 10,
               color: rgb(0, 0, 0),
           });
   
           page4.drawText(`${formData.numCivTitolare}`, {
               x: 542,
               y: 31,
               size: 10,
               color: rgb(0, 0, 0),
           });
           if(formData.statoTitolare === "IT"){
           page4.drawText(`${formData.comuneResidTitolare}`, {
               x: formData.nationality === "it" ? 185 : 200,
               y: formData.nationality === "it" ? 63 : 60,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.provinciaTitolare}`, {
            x: 419,
            y: formData.nationality === "it" ? 61 : 57,
            size: 10,
            color: rgb(0, 0, 0),
        });

         }
         else{
           page4.drawText(`${formData.localitaResidTitolare}`, {
            x: formData.nationality === "it" ? 185 : 200,
            y: formData.nationality === "it" ? 63 : 60,
             size: 10,
             color: rgb(0, 0, 0),
         });
         }
           
   
           if(formData.indirizzoTitolare != ''){
            page4.drawText(`${formData.statoTitolare}`, {
                x: 453,
                y: formData.nationality === "it" ? 61 : 57,
                size: 10,
                color: rgb(0, 0, 0),
            });
           }
          
           page4.drawText(`${formData.capTitolare}`, {
            x: formData.nationality === "it" ? 500 : 520,
            y: formData.nationality === "it" ? 61 : 57,
            size: 10,
            color: rgb(0, 0, 0),
           });
  
       
           page4.drawText(`${dataNascitaTitolareFormatted}`, {
               x: formData.nationality === "it" ? 493 : 526,
               y: formData.nationality === "it" ? 94 : 90,
               size: 10,
               color: rgb(0, 0, 0),
           });
           if(formData.statoNascitaTitolare === "IT"){
   
           page4.drawText(`${formData.comuneNascitaTitolare}`, {
               x: formData.nationality === "it" ? 160 : 185,
               y: formData.nationality === "it" ? 94 : 90,
               size: 10,
               color: rgb(0, 0, 0),
           });

           page4.drawText(`${formData.provinciaNascitaTitolare}`, {
            x: 418,
            y: formData.nationality === "it" ? 94 : 90,
            size: 10,
            color: rgb(0, 0, 0),
           });

           
         }
         else{
           page4.drawText(`${formData.luogoNascitaTitolare}`, {
            x: formData.nationality === "it" ? 160 : 185,
            y: formData.nationality === "it" ? 94 : 90,
             size: 10,
             color: rgb(0, 0, 0),
         });
         }
       
      
         if(formData.indirizzoTitolare != ''){
           page4.drawText(`${formData.statoNascitaTitolare}`, {
               x: 452,
               y: formData.nationality === "it" ? 94 : 90,
               size: 10,
               color: rgb(0, 0, 0),
           });
        }
       
   
               //------------------------------------------------------------------------- FIFTH PAGE ----------------------------------------------------------------------------------
   
               page5.drawText(`${tipoDocTitolareTranslated} - ${formData.numDocTitolare}`, {
                x:  formData.nationality === "it" ? 227 : 180,
                y: formData.nationality === "it" ? 707 : 710,
                size: 8,
                color: rgb(0, 0, 0),
                });
    
    
            page5.drawText(`${formData.indirizzoDomTitolare}`, {
                x: 160,
                y: 645,
                size:10,
                color: rgb(0, 0, 0),
            });
    
            page5.drawText(`${formData.numCivDomTitolare}`, {
                x: 538,
                y: 645,
                size: 10,
                color: rgb(0, 0, 0),
            });
    
            if(formData.statoDomTitolare === "IT"){
            page5.drawText(`${formData.comuneDomTitolare}`, {
                x:  formData.nationality === "it" ? 180 : 195,
                y: 680,
                size: 10,
                color: rgb(0, 0, 0),
            });
            }
            else{
              page5.drawText(`${formData.localitaDomTitolare}`, {
                x: formData.nationality === "it" ? 180 : 195,
                y: 680,
                size: 10,
                color: rgb(0, 0, 0),
            });
            }
            page5.drawText(`${formData.provDomTitolare}`, {
                x: 413,
                y: 679,
                size: 10,
                color: rgb(0, 0, 0),
            });
    
            if(formData.indirizzoTitolare != ''){
            page5.drawText(`${formData.statoDomTitolare}`, {
                x: 446,
                y: 679,
                size: 10,
                color: rgb(0, 0, 0),
            });
         }
            page5.drawText(`${formData.capDomTitolare}`, {
              x: formData.nationality === "it" ? 500 : 525,
              y: formData.nationality === "it" ? 679 : 681,
              size: 10,
              color: rgb(0, 0, 0),
             });

            page5.drawText(`${formData.relTitolare}`, {
                x: 120,
                y: 590,
                size: 9,
                color: rgb(0, 0, 0),
            });
   
               page5.drawText(`${formData.profCli}`, {
                   x: formData.nationality === "it" ? 360 : 375,
                   y: formData.nationality === "it" ? 195 : 189,
                   size: 9,
                   color: rgb(0, 0, 0),
               });

               page5.drawText(`${tipoDocTitolareTranslated}`, {
                x: 215,
                y: 470,
                size: 10,
                color: rgb(0, 0, 0),
              });

               page5.drawText(`${formData.numDocTitolare}`, {
                x: 400,
                y: 470,
                size: 10,
                color: rgb(0, 0, 0),
              });
    
              page5.drawText(`${dataRilascioTitolareFormatted}`, {
                x: formData.nationality === "it" ? 150 : 180,
                y: formData.nationality === "it" ? 445 : 448,
                size: 10,
                color: rgb(0, 0, 0),
              });
    
              page5.drawText(`${dataScadTitolareFormatted}`, {
                x: 400,
                y: 445,
                size: 10,
                color: rgb(0, 0, 0),
              });
    
              page5.drawText(`${formData.rilascioDocTitolare}`, {
                x: 185,
                y: 421,
                size: 10,
                color: rgb(0, 0, 0),
              });
   
              
            //CHECKBOX
   
   
               if (formData.pepTitolareOption === "pepTitolare") {
                   page5.drawText("X", {
                       x: formData.nationality === "it" ? 114 : 115,
                       y: formData.nationality === "it" ? 316 : 314,
                       size: 11, 
                       color: rgb(0, 0, 0),
                   });
                   } else if (formData.pepTitolareOption === "nonPepTitolare") {
                       page5.drawText("X", {
                       x: formData.nationality === "it" ? 114 : 115, 
                       y: formData.nationality === "it" ? 344 : 341,
                       size: 11, 
                       color: rgb(0, 0, 0),
                       });
               }
           
               page5.drawText("X", {
                   x: 114, 
                   y: 188,
                   size: 11, 
                   color: rgb(0, 0, 0),
               });
   
               page5.drawText("X", {
                   x: 112, 
                   y: 112,
                   size: 11, 
                   color: rgb(0, 0, 0),
               });
   
              
               const checkboxTipRapportoCoordinates = {
   
                   mandatoVendereBeni: { x: 129, y: 89 },
                   compravenditaBeni: { x: 330, y: 89 },
                   consulenza:{ x: 129, y: 70 },
                   stime: { x: 330, y: 70 },
                   altroTipRapporto: { x: 129, y: 49 },
                 };
               
                 Object.entries(checkboxTipRapportoCoordinates).forEach(([key, { x, y }]) => {
                   if (formData[key]) { 
                     page5.drawText("X", {
                       x,
                       y,
                       size: 11,
                       color: rgb(0, 0, 0),
                     });
                   }
                 });
   
   
   
                //TEXTAREA
   
               page5.drawText(`${formData.altroTipRapportoDescription}`, {
                   x: 223,
                   y: 51,
                   size: 9,
                   color: rgb(0, 0, 0),
               });
   
   
              
   
   
               page5.drawText(`${formData.pepTitolareText}`, {
                   x: 126,
                   y: formData.nationality === "it" ? 283 : 281,
                   size: 9,
                   color: rgb(0, 0, 0),
               });
   
   
               //------------------------------------------------------------------------- SIXTH PAGE ----------------------------------------------------------------------------------
   
               page6.drawText("X", {
                x: 113, 
                y: 692,
                size: 11, 
                color: rgb(0, 0, 0),
            });

               
               const checkboxScRapportoCoordinates = {
   
                investimentoPersonale: { x: 127, y: 669 },
                investimentoProfessionale: { x: 327, y: 670 },
                smobilizzoInvestimento: { x: 327, y: 644 },
                investimentoCommerciale: { x: 127, y: 644 },
                altroScRapporto: { x: 127, y: 621 },
                };
            
                Object.entries(checkboxScRapportoCoordinates).forEach(([key, { x, y }]) => {
                if (formData[key]) { 
                    page6.drawText("X", {
                    x,
                    y,
                    size: 11,
                    color: rgb(0, 0, 0),
                    });
                }
                });

                page6.drawText(`${formData.altroScRapportoDescription}`, {
                  x: 221,
                  y: 624,
                  size: 9,
                  color: rgb(0, 0, 0),
              });
   
               page6.drawText(`${formData.luogoForm}, ${formData.dataForm}`, {
                   x: 185,
                   y: 209,
                   size: 12,
                   color: rgb(0, 0, 0),
               });
       
   
               page6.drawText(`${identificationText}: ${formData.authCode}`, {
                 x: 180,
                 y: 159,
                 size: 12,
                 color: rgb(0, 0, 0),
             });
     
   

    const pdfBytesUpdated = await pdfDoc.save();
    return new Blob([pdfBytesUpdated], { type: "application/pdf" });
  } catch (error) {
    console.error("Error generating PDF", error);
    throw error;
  }
};
